export const ROUTE_PATHS = { 
  HOME: "/",
  TIMELINE: "/timeline",
  APPLICATIONS: "/applications",
  BAHRAIN: "/bahrain",
  FUTURE: "/future",
} as const;

export interface QuantumMilestone {
  id: string;
  year: number;
  title: string;
  description: string;
  scientist?: string;
  category: "theory" | "experiment" | "technology";
  isMajor?: boolean;
}

export interface QuantumApplication {
  id: string;
  title: string;
  industry: "Medicine" | "Computing" | "Security" | "Communication" | "Energy" | "Finance";
  description: string;
  impact: "Transformative" | "High" | "Medium";
  iconName: string;
  bahrainUseCase?: string;
}

export interface BahrainInitiative {
  id: string;
  title: string;
  partner: string;
  focus: "Research" | "Security" | "Industry" | "Education" | "Healthcare";
  status: "Active" | "Upcoming" | "Strategic Partnership";
  description: string;
  establishedYear: number;
}

export const QUANTUM_CENTENNIAL_START = 1925;
export const CURRENT_YEAR = 2026;

export function getYearsSinceQuantumDawn(currentYear: number = CURRENT_YEAR): number {
  return currentYear - QUANTUM_CENTENNIAL_START;
}

export function formatQuantumYear(year: number): string {
  return year < 0 ? `${Math.abs(year)} BCE` : `${year} CE`;
}

export function getCategoryColor(category: QuantumMilestone["category"]): string {
  switch (category) {
    case "theory":
      return "text-chart-1";
    case "experiment":
      return "text-chart-2";
    case "technology":
      return "text-chart-3";
    default:
      return "text-foreground";
  }
}

export function calculateImpactScore(impact: QuantumApplication["impact"]): number {
  const scores = {
    Transformative: 100,
    High: 75,
    Medium: 50,
  };
  return scores[impact] || 0;
}

export function isCentennialYear(year: number): boolean {
  return year === 2025 || year === 1925;
}